module.exports = __webpack_public_path__ + "static/media/Trash.dcb52c1d.svg";